import { render, staticRenderFns } from "./search-result.vue?vue&type=template&id=468ee7fc"
import script from "./search-result.vue?vue&type=script&lang=js"
export * from "./search-result.vue?vue&type=script&lang=js"
import style0 from "./search-result.vue?vue&type=style&index=0&id=468ee7fc&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports